import { render, staticRenderFns } from "./StudentStoreLayout.vue?vue&type=template&id=0f450488&scoped=true&"
import script from "./StudentStoreLayout.vue?vue&type=script&lang=js&"
export * from "./StudentStoreLayout.vue?vue&type=script&lang=js&"
import style0 from "./StudentStoreLayout.vue?vue&type=style&index=0&id=0f450488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f450488",
  null
  
)

export default component.exports